import React from 'react';
import PropTypes from 'prop-types';
import { useFeatureFlag } from 'common/hooks';
import { StatusBadge } from 'src/common/badges';
import { ENROLLMENT_STATUSES } from 'src/pages/enrollments/constants';

const badgeProps = {
  open: {
    className: 'bg-dark-border-blue text-text-blue',
    label: 'Open',
  },
  canceled: {
    className: 'bg-action-blue text-white',
    label: 'Canceled',
  },
  accepted: {
    className: 'bg-dark-green text-white',
    label: 'Accepted',
  },
  rejected: {
    className: 'bg-red text-white',
    label: 'Rejected',
  },
  in_review: {
    className: 'bg-orange text-white',
    label: 'In Review',
  },
};

const validStatuses = Object.keys(badgeProps);

const EnrollmentStatusIndicator = ({ status, isUrgent }) => {
  const markAsUrgentEnabled = useFeatureFlag('pays-enrollment-mark-as-urgent');

  if (!validStatuses.includes(status)) return '';
  const { className, label } = badgeProps[status];

  const isOpenOrInReview = status === ENROLLMENT_STATUSES.open || status === ENROLLMENT_STATUSES.inReview;
  const shouldShowUrgent = markAsUrgentEnabled && isUrgent === true && isOpenOrInReview;

  if (shouldShowUrgent) {
    return (
      <div className="inline-flex items-center flex-nowrap gap-2 whitespace-nowrap">
        <StatusBadge className={className} label={label} />
        <span className="text-red font-bold text-xs flex-shrink-0">Urgent</span>
      </div>
    );
  }

  return <StatusBadge className={className} label={label} />;
};

EnrollmentStatusIndicator.propTypes = {
  status: PropTypes.oneOf(validStatuses).isRequired,
  isUrgent: PropTypes.bool,
};

EnrollmentStatusIndicator.defaultProps = {
  isUrgent: false,
};

export default EnrollmentStatusIndicator;
